import { render, staticRenderFns } from "./temp-carrier-alert.vue?vue&type=template&id=767be2d4&scoped=true&"
import script from "./temp-carrier-alert.vue?vue&type=script&lang=js&"
export * from "./temp-carrier-alert.vue?vue&type=script&lang=js&"
import style0 from "./temp-carrier-alert.vue?vue&type=style&index=0&id=767be2d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767be2d4",
  null
  
)

export default component.exports